// The glossary one language at a time, loaded with a term's page (App.tsx): every term page used
// to load all four languages (~30 KB compressed). The tests register all four (tests/setup.ts).
export const GLOSSARY_LOADERS = {
  en: () => import('./glossary.en'),
  es: () => import('./glossary.es'),
  pt: () => import('./glossary.pt'),
  ar: () => import('./glossary.ar'),
  fr: () => import('./glossary.fr'),
  de: () => import('./glossary.de'),
};

const loaded = {};

export function registerGlossary(locale, copy) {
  loaded[locale] = copy;
}

/** A loaded language's glossary, or null until it has loaded. */
export function glossaryOf(locale) {
  return loaded[locale] || null;
}

/** Load a language's glossary (once) and keep it. */
export function loadGlossary(locale) {
  if (loaded[locale] || !GLOSSARY_LOADERS[locale]) return Promise.resolve();
  return GLOSSARY_LOADERS[locale]().then((mod) => registerGlossary(locale, mod.default));
}
